import React from 'react';
import { observer } from 'mobx-react';

const Dialog = observer(class Dialog extends React.Component {
  constructor() {
    super();
    this.closeDialog = this.closeDialog.bind(this);
  }

  closeDialog(e) {
    const { SessionStore } = this.props.store;

    e.preventDefault();

    // Clear out session storage and redirect if the session has expired
    if(SessionStore.dialogContent.code === '5002' || SessionStore.dialogContent.code === '5003') {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('iam');
      sessionStorage.removeItem('userData');
      sessionStorage.removeItem('registerData');
      this.props.routing.history.push('/account/sign-in');
    }

    // Remove dialog
    this.props.store.SessionStore.closeDialog();
  }

  render() {
    const { SessionStore, LocationStore } = this.props.store;

    return(
      <div className="dialog">
        <div className="dialog__content">
          <strong className="dialog__msg">{SessionStore.dialogContent.heading}</strong>

          <p>{SessionStore.dialogContent.body}</p>

          <a href="#app" className="btn" onClick={(e) => this.closeDialog(e)}>{SessionStore.dialogContent.button}</a>

          {SessionStore.dialogContent.typeForm &&
            <a
              className="btn btn--outline"
              href={`https://smarterservices.typeform.com/to/nsgGZf?proctorlocationsid=${LocationStore.locationSid}&proctoraccountsid=${SessionStore.userData.proctorAccountSid}&proctorusersid=${SessionStore.userData.sid}&firstname=${SessionStore.userData.firstName}&lastname=${SessionStore.userData.lastName}&email=${SessionStore.userData.email}`}
              target="_blank"
            >
              Contact us
            </a>
          }
        </div>
      </div>
    );
  }
})

export default Dialog;



// WEBPACK FOOTER //
// ./src/app/components/Common/Dialog.js